var SearchResultCardEnum = /* @__PURE__ */ ((SearchResultCardEnum2) => {
  SearchResultCardEnum2["SEARCH_TAG"] = "search-tag--search-card";
  SearchResultCardEnum2["SEARCH_TAG_ICON"] = "search-tag-icon--search-card";
  SearchResultCardEnum2["SEARCH_TAG_LABEL"] = "search-tag-label--search-card";
  SearchResultCardEnum2["SEARCH_TAG_DISCOUNT"] = "search-tag-discount--search-card";
  SearchResultCardEnum2["BUTTON_SEE_SCHEDULE"] = "button-see-schedule--search-result";
  SearchResultCardEnum2["SEARCH_ENTITY_RATING"] = "search-entity-rating";
  SearchResultCardEnum2["PROFESSIONAL_NAME_SEARCH_PARTNER_PROFILE"] = "professional-name--search-partner-profile";
  SearchResultCardEnum2["PARTNER_NAME_SEARCH_PARTNER_PROFILE"] = "partner-name--search-partner-profile";
  SearchResultCardEnum2["SEARCH_CARD_CONTAINER"] = "search-card-container";
  SearchResultCardEnum2["SEARCH_CARD_PROMOTIONAL_PILL"] = "search-card-promotional-pill";
  SearchResultCardEnum2["SEARCH_CARD_PRICE_BUTTON"] = "search-card-price-button";
  SearchResultCardEnum2["SEARCH_CARD_PRICE_BUTTON_PROMOTIONAL"] = "search-card-price-button-promotional";
  SearchResultCardEnum2["SEARCH_PARTNER_AVATAR_LINK"] = "search-partner-avatar-link";
  SearchResultCardEnum2["SEARCH_PARTNER_PROFILE_NAME_LINK"] = "search-partner-profile-name-link";
  SearchResultCardEnum2["SEARCH_PARTNER_ADDRESS_EXPAND_BUTTON"] = "search-partner-address-expand-button";
  SearchResultCardEnum2["SEARCH_PARTNER_ADDRESS_FULL_ADDRESS_LINK"] = "search-partner-address-full-address-link";
  SearchResultCardEnum2["SEARCH_PARTNER_ADDRESS_MAP_LINK"] = "search-partner-address-map-link";
  SearchResultCardEnum2["SEARCH_PARTNER_ADDRESS_TELEHEALTH_INDICATOR"] = "search-partner-address-telehealth-indicator";
  SearchResultCardEnum2["SEARCH_PARTNER_PROFILE_ADDRESS_ADDRESS_LINK"] = "search-partner-profile-address-address-link";
  SearchResultCardEnum2["SEARCH_PARTNER_PROFILE_ADDRESS_MAP_LINK"] = "search-partner-profile-address-map-link";
  SearchResultCardEnum2["SEARCH_PARTNER_PROFILE_ADDRESS_TELEHEALTH_INDICATOR"] = "search-partner-profile-address-telehealth-indicator";
  return SearchResultCardEnum2;
})(SearchResultCardEnum || {});
export {
  SearchResultCardEnum
};
